// src/app/redux/sagas/sectionSagas.js

import { call, put, takeLatest } from 'redux-saga/effects';
import { getRequest, postRequest, deleteRequest } from '../../../api';
import Swal from "sweetalert2";
import {
    FETCH_SECTIONS_REQUEST,
    FETCH_SECTIONS_SUCCESS,
    FETCH_SECTIONS_FAIL,
    SAVE_SECTION_REQUEST,
    SAVE_SECTION_SUCCESS,
    SAVE_SECTION_FAIL,
    DELETE_SECTION_REQUEST,
    DELETE_SECTION_SUCCESS,
    DELETE_SECTION_FAIL,
    FETCH_AVAILABLE_FIELDS_REQUEST,
    FETCH_AVAILABLE_FIELDS_SUCCESS,
    FETCH_AVAILABLE_FIELDS_FAIL,
} from '../actions/sectionActions';

import { API_BASE_URL } from '../../../api';

const API_URL = `${API_BASE_URL}/api/user-field-sections`;

function* fetchSectionsSaga(action) {
    try {
        const response = yield call(getRequest, { url: `${API_URL}?companyId=${action.payload}`, token: sessionStorage.getItem('token') });
        yield put({ type: FETCH_SECTIONS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FETCH_SECTIONS_FAIL, payload: error.message });
    }
}

function* saveSectionSaga(action) {
    try {
        const response = yield call(postRequest, { url: API_URL, data: action.payload, token: sessionStorage.getItem('token') });
        yield put({ type: SAVE_SECTION_SUCCESS, payload: response.data });
        
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Section enregistrée avec succès',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put({ type: SAVE_SECTION_FAIL, payload: error.message });
        
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de l'enregistrement de la section",
            timer: 2500,
            showConfirmButton: false
        });
    }
}

function* deleteSectionSaga(action) {
    try {
        yield call(deleteRequest, { url: `${API_URL}/${action.payload}`, token: sessionStorage.getItem('token') });
        yield put({ type: DELETE_SECTION_SUCCESS, payload: action.payload });
        
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Section supprimée',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put({ type: DELETE_SECTION_FAIL, payload: error.message });
        
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la suppression",
            timer: 2500,
            showConfirmButton: false
        });
    }
}

function* fetchAvailableFieldsSaga() {
    try {
        const response = yield call(getRequest, { url: `${API_BASE_URL}/api/user-fields/available`, token: sessionStorage.getItem('token') });
        yield put({ type: FETCH_AVAILABLE_FIELDS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FETCH_AVAILABLE_FIELDS_FAIL, payload: error.message });
    }
}

export default function* sectionSaga() {
    yield takeLatest(FETCH_SECTIONS_REQUEST, fetchSectionsSaga);
    yield takeLatest(SAVE_SECTION_REQUEST, saveSectionSaga);
    yield takeLatest(DELETE_SECTION_REQUEST, deleteSectionSaga);
    yield takeLatest(FETCH_AVAILABLE_FIELDS_REQUEST, fetchAvailableFieldsSaga);
}
